export default {
  methods: {
    showLoading() {
      this.$store.commit("showLoading");
    },
    clearLoading() {
      this.$store.commit("clearLoading");
    },
  },
};
